// @flow

/*
  Transforms a number from one scale (defaults to 0-1)
  to a new scale between newMin-newMax
*/
export default function normalize(
  number: number,
  newMin: number,
  newMax: number,
  oldMin?: number = 0,
  oldMax?: number = 1
): number {
  return ((newMax - newMin) * (number - oldMin)) / (oldMax - oldMin) + newMin
}
